import axios from 'axios';
import {backendHost} from '../../config';

export const putGame = (params) => {
    return axios.put(`${backendHost}/api/admin/v2/games/game`, params);
};